import {match} from 'ts-pattern';

import {SourcingType} from '../../../hooks/useSourcingType';
import {
  ClassifiedsAdInactiveFlags,
  isClassifiedsAdInactive,
} from '../../../utils/isClassifiedsAdInactive';

export function isVehicleEligibleToPushToSale(
  sourcingType: SourcingType,
  vehicle: ClassifiedsAdInactiveFlags
): boolean {
  return match(sourcingType)
    .with(SourcingType.AUCTIONS, () => true)
    .with(SourcingType.CLASSIFIEDS, () => !isClassifiedsAdInactive(vehicle))
    .exhaustive();
}
